module.exports = __webpack_public_path__ + "leading-edge.1iuSR47d.svg";